const base_path = "/new_images/ceramic_coating/5__MG_Hector/";

const file_names: string[] = [
    "1", // preview
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "11",
]

const file_names_sizes: {[key: string]: {w: number, h: number}} = {
    "1": {w: 810, h: 1080},
    "2": {w: 1080, h: 810},
    "3": {w: 1080, h: 810},
    "4": {w: 1080, h: 810},
    "5": {w: 810, h: 1080},
    "6": {w: 1080, h: 810},
    "7": {w: 810, h: 1080},
    "8": {w: 1080, h: 810},
    "9": {w: 810, h: 1080},
    "10": {w: 1080, h: 810},
    "11": {w: 810, h: 1080},
}

export const MG_Hector = file_names.map((f) => {
    const size = file_names_sizes[f];

    return {
        jpg: base_path+f+".jpeg",
        webp: base_path+f+".webp",
        alt: "MG Hector",
        w: size.w.toString(),
        h: size.h.toString(),
    }
});